import { useNavigate } from "react-router-dom";
import { Sparkles, Image as ImageIcon, Settings, Users, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";
import { useLang } from "../../lib/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div className="hero-section">
      <div className="hero-bg" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1712076108647-086130c02308?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxuZW9uJTIwY2l0eSUyMG5pZ2h0JTIwYWVzdGhldGljfGVufDB8fHx8MTc3MzM0NjM0NHww&ixlib=rb-4.1.0&q=85')` }} />
      <div className="hero-overlay" />
      <div className="relative z-10 min-h-screen flex flex-col">
        <header className="flex items-center justify-between px-6 md:px-12 lg:px-24 py-6">
          <div className="flex items-center gap-3">
            <Sparkles className="w-8 h-8 text-primary" />
            <span className="text-xl font-bold">AI Model Creator</span>
          </div>
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <Button onClick={() => navigate('/dashboard')} variant="outline" className="border-white/20 hover:bg-white/10" data-testid="header-dashboard-btn">
              {t('dashboard')}
            </Button>
          </div>
        </header>

        <div className="flex-1 flex items-center px-6 md:px-12 lg:px-24">
          <div className="max-w-2xl animate-fade-in-up">
            <div className="accent-line mb-8" />
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
              {t('heroTitle1')} <br />
              <span className="gradient-text">{t('heroTitle2')}</span>
            </h1>
            <p className="text-lg text-text-secondary mb-8 max-w-lg">{t('heroDescription')}</p>
            <div className="flex flex-wrap gap-4">
              <Button onClick={() => navigate('/dashboard')} className="bg-gradient-to-r from-primary to-secondary hover:opacity-90 text-white font-semibold px-8 py-6 rounded-xl btn-glow" data-testid="hero-start-btn">
                {t('startCreating')} <ChevronRight className="ml-2 w-5 h-5" />
              </Button>
              <Button variant="outline" className="border-white/20 hover:bg-white/10 px-8 py-6 rounded-xl" data-testid="hero-learn-more-btn">
                {t('learnMore')}
              </Button>
            </div>
          </div>
        </div>

        <div className="px-6 md:px-12 lg:px-24 pb-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              <ImageIcon className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('featureImages')}</h3>
              <p className="text-text-secondary text-sm">{t('featureImagesDesc')}</p>
            </div>
            <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <Settings className="w-10 h-10 text-secondary mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('featureControl')}</h3>
              <p className="text-text-secondary text-sm">{t('featureControlDesc')}</p>
            </div>
            <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <Users className="w-10 h-10 text-accent mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('featureGallery')}</h3>
              <p className="text-text-secondary text-sm">{t('featureGalleryDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
